// extracted by mini-css-extract-plugin
export default {"wrapper_qr_video":"qr_style_wrapper_qr_video__mRlj-","wrapper_qr_video_error":"qr_style_wrapper_qr_video_error__1Wd2G","window":"qr_style_window__cdPoX"};